
window.klaroConfig = {
  elementID: 'klaro',
  storageMethod: 'cookie',
  cookieName: 'klaro',
  htmlTexts: true,
  default: false,
  mustConsent: true,
  acceptAll: true,
  services: [
    {
      name: 'googleAnalytics',
      title: 'Google Analytics',
      purposes: ['analytics'],
      cookies: [
        [/^_ga/, '/', 'auto'],
        '_gid',
        '_gat',
      ],
      required: false,
      default: false,
      optOut: false,
      onlyOnce: true,
      callback: function(consent, service) {
        if (consent) {
          loadGoogleAnalytics();
        }
      }
    },

    {
      name: 'googleMaps',
      title: 'Google Maps',
      purposes: ['functional'],
      cookies: [
        [/^NID/, '/', 'auto'],
        [/^SID/, '/', 'auto'],
        [/^HSID/, '/', 'auto'],
      ],
      default: false,
      onlyOnce: true,
      callback: function(consent, service) {
        if (consent) {
          loadGoogleMaps();
        }
      }
    }
  ],
  translations: {
    en: {
      consentModal: {
        title: 'Cookie Preferences',
        description: 'Here you can customize your consent preferences for the use of cookies and similar technologies. To learn more, please read our <a href="/assets/privacy_policy.pdf" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and <a href="/assets/cookie_policy.pdf" target="_blank" rel="noopener noreferrer">Cookie Policy</a>.'
      },
      purposes: {
        analytics: 'Analytics',
        functional: 'Maps'
      },
      services: {
        googleAnalytics: {
          description: 'Used to collect information about how you use our site.'
        },
        googleMaps: {
          description: 'Used to embed interactive maps from Google.'
        }
      }
    }
  }
};

function loadGoogleAnalytics() {
  var script = document.createElement('script');
  script.src = 'https://www.googletagmanager.com/gtag/js?id=UA-66625409-1';
  script.async = true;
  document.head.appendChild(script);

  script.onload = function () {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    window.gtag = gtag;

    gtag('js', new Date());
    gtag('config', 'UA-66625409-1');
  }
}

function loadGoogleMaps() {
  if (window.google && window.google.maps) {
    initGoogleMaps(); // If already loaded, initialize immediately
    return;
  }

  const script = document.createElement('script');
  const googleApiKey = document.querySelector('meta[name="google-api-key"]').content;
  script.src = `https://maps.googleapis.com/maps/api/js?key=${googleApiKey}&callback=initGoogleMaps`; // <-- Calls initGoogleMaps when loaded
  script.async = true;
  document.head.appendChild(script);
}